// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={294}
    height={204}
    viewBox="0 0 294 204"
    {...props}
  >
    <g clipPath="url(#clip0_4351_52865)">
      <g clipPath="url(#clip1_4351_52865)">
        <path
          d="M122.774 102.342C124.395 102.342 125.686 102.737 127.049 104.206L147.491 126.218H115.085C113.02 126.218 111.04 125.398 109.58 123.938C108.12 122.478 107.3 120.497 107.3 118.432H104.3C102.236 118.432 100.257 117.613 98.7975 116.154C97.338 114.695 96.5177 112.716 96.5169 110.653V110.392H95.3023C94.28 110.392 93.2676 110.191 92.3231 109.8C91.3785 109.409 90.5202 108.836 89.7972 108.113C89.0742 107.391 88.5006 106.532 88.1093 105.588C87.718 104.644 87.5166 103.631 87.5166 102.609V102.348L122.774 102.342Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M96.5176 110.387H122.073"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M128.47 118.432H107.299"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M175.457 102.342C173.835 102.342 172.545 102.737 171.181 104.206L150.742 126.218H183.148C184.17 126.218 185.183 126.017 186.127 125.625C187.072 125.234 187.93 124.661 188.652 123.938C189.375 123.215 189.948 122.356 190.339 121.412C190.73 120.467 190.931 119.455 190.931 118.432H193.931C195.996 118.432 197.976 117.612 199.436 116.152C200.896 114.692 201.717 112.712 201.717 110.647V110.386H202.931C204.995 110.386 206.975 109.566 208.434 108.106C209.894 106.647 210.714 104.667 210.714 102.603V102.342H175.457Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M201.727 110.387H176.172"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M169.772 118.432H190.943"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M148.957 94.7656L95.96 187.511H201.953L148.957 94.7656Z"
          fill="#FFB743"
          stroke="#37363F"
          strokeWidth={1.30286}
          strokeMiterlimit={10}
        />
        <path
          d="M153.524 127.182H144.39V160.814H153.524V127.182Z"
          fill="#FCFBF7"
        />
        <path
          d="M153.704 170.255C153.704 171.515 153.204 172.723 152.313 173.613C151.423 174.504 150.215 175.004 148.955 175.004C147.696 175.004 146.488 174.504 145.597 173.613C144.706 172.723 144.206 171.515 144.206 170.255C144.206 168.995 144.706 167.788 145.597 166.897C146.488 166.006 147.696 165.506 148.955 165.506C150.215 165.506 151.423 166.006 152.313 166.897C153.204 167.788 153.704 168.995 153.704 170.255Z"
          fill="#FCFBF7"
        />
      </g>
      <g clipPath="url(#clip2_4351_52865)">
        <path
          d="M242.581 32.7675C243.351 33.073 243.889 33.5035 244.259 34.4579L249.814 48.7563L234.434 42.651C233.454 42.2619 232.668 41.4995 232.251 40.5315C231.833 39.5634 231.816 38.469 232.205 37.489L230.782 36.9237C229.802 36.535 229.017 35.7731 228.599 34.8058C228.182 33.8384 228.165 32.7447 228.554 31.7652L228.603 31.6412L228.026 31.4124C227.541 31.22 227.098 30.9339 226.724 30.5703C226.349 30.2068 226.05 29.7731 225.843 29.2939C225.636 28.8146 225.525 28.2993 225.517 27.7774C225.51 27.2554 225.605 26.737 225.797 26.2518L225.847 26.1279L242.581 32.7675Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M228.604 31.6387L240.732 36.4533"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M242.253 41.4769L232.205 37.4883"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M267.586 42.6933C266.817 42.3878 266.13 42.332 265.206 42.7727L251.358 49.3691L266.738 55.4744C267.224 55.667 267.742 55.7621 268.264 55.7543C268.786 55.7466 269.301 55.636 269.78 55.429C270.26 55.222 270.693 54.9227 271.057 54.548C271.42 54.1733 271.707 53.7308 271.899 53.2455L273.323 53.8107C274.303 54.1997 275.397 54.1835 276.365 53.7656C277.333 53.3477 278.096 52.5624 278.485 51.5823L278.534 51.4584L279.111 51.6872C280.09 52.0761 281.184 52.0599 282.152 51.6421C283.12 51.2244 283.882 50.4394 284.271 49.4597L284.32 49.3358L267.586 42.6933Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M278.538 51.4612L266.409 46.6465"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M261.857 49.2598L271.905 53.2484"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M256.435 34.1057L213.809 68.139L264.115 88.1083L256.435 34.1057Z"
          fill="#0078EF"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M252.495 50.3517L248.16 48.6309L241.824 64.5934L246.159 66.3142L252.495 50.3517Z"
          fill="#FCFBF7"
        />
        <path
          d="M244.467 70.8267C244.229 71.4245 243.764 71.9035 243.174 72.1585C242.583 72.4134 241.916 72.4233 241.318 72.186C240.72 71.9487 240.241 71.4836 239.986 70.8931C239.731 70.3026 239.721 69.635 239.959 69.0372C240.196 68.4394 240.661 67.9604 241.252 67.7055C241.842 67.4506 242.51 67.4406 243.108 67.6779C243.705 67.9152 244.184 68.3803 244.439 68.9708C244.694 69.5613 244.704 70.2289 244.467 70.8267Z"
          fill="#FCFBF7"
        />
      </g>
      <g clipPath="url(#clip3_4351_52865)">
        <path
          d="M26.0949 63.5951C26.8819 63.3378 27.5709 63.3247 28.4659 63.8216L41.8803 71.2618L26.1517 76.4037C25.1495 76.7313 24.0582 76.6474 23.1178 76.1704C22.1775 75.6934 21.4651 74.8624 21.1375 73.8602L19.6813 74.3362C18.6798 74.6637 17.5892 74.5799 16.6493 74.1034C15.7095 73.6269 14.9974 72.7966 14.6695 71.7952L14.6281 71.6684L14.0386 71.8612C13.5425 72.0236 13.0192 72.0866 12.4987 72.0468C11.9782 72.0069 11.4707 71.8649 11.0051 71.6288C10.5395 71.3928 10.125 71.0673 9.78518 70.671C9.4454 70.2747 9.18703 69.8153 9.02482 69.3191L8.98339 69.1924L26.0949 63.5951Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M14.627 71.6641L27.0306 67.6091"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M31.4122 70.5021L21.1367 73.8613"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M51.6663 55.2348C50.8793 55.4921 50.3155 55.8884 49.887 56.8181L43.4594 70.7449L59.188 65.603C59.6841 65.4408 60.1435 65.1824 60.5398 64.8426C60.9361 64.5028 61.2616 64.0883 61.4976 63.6227C61.7337 63.1571 61.8757 62.6495 61.9156 62.129C61.9555 61.6086 61.8924 61.0853 61.73 60.5892L63.1861 60.1132C64.1883 59.7856 65.0194 59.0732 65.4964 58.1328C65.9734 57.1925 66.0573 56.1012 65.7296 55.0989L65.6882 54.9722L66.2777 54.7795C67.2795 54.452 68.1102 53.7399 68.587 52.7999C69.0639 51.8599 69.1477 50.769 68.8202 49.7672L68.7788 49.6404L51.6663 55.2348Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M65.6927 54.9704L53.2891 59.0254"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M51.4609 63.9453L61.7364 60.5861"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M37.6014 55.7628L26.5949 109.187L78.04 92.3685L37.6014 55.7628Z"
          fill="#46E8A8"
          stroke="#37363F"
          strokeWidth={0.665291}
          strokeMiterlimit={10}
        />
        <path
          d="M44.9616 70.7714L40.5283 72.2207L45.8649 88.5447L50.2981 87.0954L44.9616 70.7714Z"
          fill="#FCFBF7"
        />
        <path
          d="M51.8842 91.6476C52.084 92.2589 52.0328 92.9246 51.7419 93.4982C51.4509 94.0718 50.944 94.5063 50.3327 94.7062C49.7213 94.906 49.0556 94.8548 48.482 94.5639C47.9084 94.2729 47.4739 93.766 47.2741 93.1547C47.0742 92.5433 47.1254 91.8777 47.4164 91.3041C47.7073 90.7305 48.2142 90.2959 48.8256 90.0961C49.4369 89.8962 50.1026 89.9474 50.6762 90.2384C51.2498 90.5293 51.6843 91.0362 51.8842 91.6476Z"
          fill="#FCFBF7"
        />
      </g>
      <g clipPath="url(#clip4_4351_52865)">
        <path
          d="M115.075 9.12891C115.696 9.12891 116.19 9.28009 116.712 9.84295L124.541 18.273H112.131C111.34 18.273 110.581 17.9589 110.022 17.3997C109.463 16.8405 109.149 16.0821 109.149 15.2913H108C107.209 15.2913 106.452 14.9774 105.893 14.4187C105.334 13.86 105.02 13.1021 105.019 12.3118V12.2118H104.554C104.163 12.212 103.775 12.135 103.413 11.9853C103.051 11.8356 102.723 11.616 102.446 11.3393C102.169 11.0625 101.949 10.7338 101.799 10.3721C101.649 10.0104 101.572 9.62276 101.572 9.23124V9.13123L115.075 9.12891Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M105.02 12.209H114.807"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M117.256 15.291H109.148"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M135.251 9.12891C134.63 9.12891 134.136 9.28009 133.614 9.84295L125.786 18.273H138.197C138.588 18.273 138.976 18.1959 139.338 18.046C139.7 17.8962 140.028 17.6765 140.305 17.3996C140.582 17.1227 140.801 16.794 140.951 16.4322C141.101 16.0705 141.178 15.6828 141.178 15.2913H142.326C143.117 15.2913 143.876 14.9771 144.435 14.4179C144.994 13.8587 145.308 13.1003 145.308 12.3095V12.2095H145.773C146.564 12.2095 147.322 11.8955 147.881 11.3365C148.44 10.7775 148.754 10.0194 148.754 9.22892V9.12891H135.251Z"
          fill="#FCFBF7"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M145.312 12.209H135.524"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M133.075 15.291H141.183"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M125.102 6.22656L104.806 41.746H145.399L125.102 6.22656Z"
          fill="#FF73A9"
          stroke="#37363F"
          strokeWidth={0.6}
          strokeMiterlimit={10}
        />
        <path
          d="M126.852 18.6406H123.354V31.5212H126.852V18.6406Z"
          fill="#FCFBF7"
        />
        <path
          d="M126.921 35.1372C126.921 35.6196 126.729 36.0822 126.388 36.4233C126.047 36.7644 125.584 36.956 125.102 36.956C124.62 36.956 124.157 36.7644 123.816 36.4233C123.475 36.0822 123.283 35.6196 123.283 35.1372C123.283 34.6548 123.475 34.1922 123.816 33.8511C124.157 33.51 124.62 33.3184 125.102 33.3184C125.584 33.3184 126.047 33.51 126.388 33.8511C126.729 34.1922 126.921 34.6548 126.921 35.1372Z"
          fill="#FCFBF7"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4351_52865">
        <rect
          width={293.824}
          height={203.579}
          fill="white"
          transform="translate(0.0878906)"
        />
      </clipPath>
      <clipPath id="clip1_4351_52865">
        <rect
          width={125.075}
          height={125.075}
          fill="white"
          transform="translate(86.5762 78.5039)"
        />
      </clipPath>
      <clipPath id="clip2_4351_52865">
        <rect
          width={63.868}
          height={63.868}
          fill="white"
          transform="translate(229.893 14.6367) rotate(21.6509)"
        />
      </clipPath>
      <clipPath id="clip3_4351_52865">
        <rect
          width={63.868}
          height={63.868}
          fill="white"
          transform="translate(4.74512 57.7676) rotate(-18.1034)"
        />
      </clipPath>
      <clipPath id="clip4_4351_52865">
        <rect
          width={47.901}
          height={47.901}
          fill="white"
          transform="translate(101.212)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgError = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgError;
